import { render, staticRenderFns } from "./notes.html?vue&type=template&id=41641e69&scoped=true&external"
import script from "./notes.js?vue&type=script&lang=js&external"
export * from "./notes.js?vue&type=script&lang=js&external"
import style0 from "./notes.scss?vue&type=style&index=0&id=41641e69&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41641e69",
  null
  
)

export default component.exports